// @ts-nocheck
import { IconOffset, IconDefinitionProps } from "@toolkit/Framework/Types/Icon";
import React, { FC, memo } from "react";
import parseIconDefinitionProps from "@toolkit/Framework/Common/Utilities/parseIconDefinitionProps";

const PinLine: FC<IconDefinitionProps> = props => {
    const { size, color } = parseIconDefinitionProps(props);

    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
            <path
                d="M12 2l.247.004A8 8 0 0120 9.92c0 5.48-7 11.58-7.35 11.84a1 1 0 01-1.3 0l-.022-.019C10.805 21.286 4 15.304 4 9.92A8 8 0 0112 2zm0 1.92a6 6 0 00-6 6l.008.274C6.21 13.864 10.37 18.1 12 19.65c1.67-1.59 6-6.03 6-9.73l-.004-.225A6 6 0 0012 3.92zM12 6l.192.005A3.5 3.5 0 0115.5 9.5l-.005.192A3.5 3.5 0 1112 6zm0 2a1.5 1.5 0 000 3l.144-.007A1.5 1.5 0 0013.5 9.5l-.007-.144A1.5 1.5 0 0012 8z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
};

export const PinLineOffset: IconOffset = {
    vertical: 8,
    horizontal: 17,
};

export default memo(PinLine);
